// @ts-strict
import EppoFlags from '@/EppoFlags';
import {useStringAssignment} from '@/eppoHooks';

const useSupportMessageEnabled = (): boolean =>
  useStringAssignment(EppoFlags.EnableSalesforceSupportMessage) === 'treatment';

export default useSupportMessageEnabled;
